import { useEffect, useState } from 'react';
import { Admin } from '../../../clients/quipli-service/admin/admin';
import { Dispatch, Order } from '../../../clients/quipli-service/order/order';
import { useAPI } from '../../../clients/quipli-service/quipli-service-client';
import {
  OrderCardProcessedDetails,
  OrderDirection,
  orderToOrderCardPropsMapper,
} from '../../home/dashboard-v2/dashboard-utils';
import { Modal } from '../../../components/modal/modal';
import { Button } from '../../../components/form/button';
import { CardType, OrderCard } from '../../home/dashboard-v2/order-card';
import { Location } from '../../../clients/quipli-service/location/location';
import { DateTime } from 'luxon';
import { toast } from '../../../util/toasts';
import '../dispatch-v2.scss';
import { DispatchProgress } from '../../../clients/quipli-service/dispatch/dispatch';

export const DispatchCardModal = ({
  isOpen,
  setIsOpen,
  location,
  dispatch,
  onReload,
  allDrivers,
  unitTrackingViaUnitNum,
}: {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  location?: Location;
  dispatch?: Dispatch;
  allDrivers: Admin[];
  onReload: any;
  unitTrackingViaUnitNum: boolean;
}) => {
  const { getOrderById } = useAPI();
  const [orderCardProps, setOrderCardProps] = useState<OrderCardProcessedDetails>();

  const search = async () => {
    if (isOpen && dispatch && location) {
      getOrderById(dispatch.orderId)
        .then((order) => {
          const direction =
            dispatch.products.delivery && dispatch.products.delivery.length > 0
              ? OrderDirection.GoingOut
              : OrderDirection.ComingIn;
          const dispatchProducts = (
            direction === OrderDirection.GoingOut ? dispatch.products.delivery : dispatch.products.pickup
          )?.map((p) => p.id);

          const orderProductsInDispatch = order.products.filter((op) => dispatchProducts?.includes(op.id));

          const orderWithJustProductData: Order = {
            ...order,
            products: orderProductsInDispatch,
          };

          setOrderCardProps({
            ...orderToOrderCardPropsMapper(orderWithJustProductData, DateTime.local(), location, [direction]),
            scheduledDate: dispatch.scheduledTime,
          });
        })
        .catch(() => {
          toast('Failed to load order details', 'error');
        });
    }
  };
  useEffect(() => {
    search();
  }, [dispatch, location]);

  return (
    <Modal
      isOpen={isOpen}
      close={() => setIsOpen(false)}
      title="Dispatch Details"
      className="order-card-modal"
      actions={
        <>
          <Button className="button button-secondary" onClick={() => setIsOpen(false)}>
            Close
          </Button>
        </>
      }
    >
      {orderCardProps && (
        <OrderCard
          cardType={CardType.Dispatch}
          orderCardDetails={{
            ...orderCardProps,
            direction: [
              dispatch?.products.delivery && dispatch?.products.delivery.length > 0
                ? OrderDirection.GoingOut
                : OrderDirection.ComingIn,
            ],
            dispatchStatus: dispatch?.status ?? DispatchProgress.PENDING,
          }}
          onReload={async () => {
            await onReload();
            setIsOpen(false);
          }}
          location={location}
          drivers={allDrivers}
          unitTrackingViaUnitNum={unitTrackingViaUnitNum}
        />
      )}
    </Modal>
  );
};
